import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { problems } from '../../data/problems';
export function Problems() {
  return <section aria-labelledby="problems-title" className="bg-ink py-14 text-white sm:py-20 lg:py-24" data-id="element-235" data-mp="1d066xfzurfk6">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-236" data-mp="1hypt9hicytd2">
        <SectionHeading id="problems-title" eyebrow="Sound familiar?" lead="Teaching badminton is fun." highlight="Planning it from scratch isn’t." data-id="element-237" data-mp="1hy7zqsn2yt8u" />

        <ul className="mt-10 grid gap-3 sm:mt-12 sm:gap-4 md:grid-cols-2 md:gap-5" data-id="element-238" data-mp="palkuo8ek26o">
          {problems.map(problem => <li key={problem.title} className="flex gap-4 rounded-xl border border-white/10 bg-card p-5 sm:p-7" data-id="element-239" data-mp="z055nzfoe646">
              <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-alert text-alert" data-id="element-240" data-mp="1kzm21vxzoz7">
                <XIcon className="h-5 w-5" strokeWidth={2.75} data-id="element-241" data-mp="66z711efvh4r" />
              </span>
              <div data-id="element-242" data-mp="185t57v8po42">
                <h3 className="font-display text-[24px] font-bold uppercase leading-tight" data-id="element-243" data-mp="17matq1ogxpi">{problem.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-white/75" data-id="element-244" data-mp="3sm1r9gfshu8w">{problem.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-3xl text-center font-display text-[28px] sm:mt-14 sm:text-[30px] font-bold uppercase leading-[1.05] text-gold sm:text-[40px]" data-id="element-245" data-mp="3nlnskp02vwnj">
          What if your next lesson was already planned before you reached the gym?
        </p>
      </div>
    </section>;
}